<template>
    <div class="loader-svg" :class="{ loaded: !isShow }">
        <!-- <img src="@/assets/processing-request.gif" alt="" /> -->
        <div class="modal-loading-content">Loading...</div>
    </div>
</template>

<script>
export default {
    name: "Loading",
    props: {
        isShow: Boolean,
    },
    data: function () {
        return {};
    },
    created() {},
    methods: {},
};
</script>

<style lang="scss">
@import "@/module/Menu/style/mission.scss";
@import "@/style/_mixin.scss";
.loader-svg {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(#000, 52%);
    color: #fff;
    text-align: center;
    z-index: 99999;
    &.loaded {
        display: none;
    }
    .modal-loading-content {
        color: $color-text;
        margin: auto;
        display: block;
        position: absolute;
        left: 0;
        right: 0;
        top: 45%;
        max-width: 250px;
        background: $color-light-grey-500;
        border-radius: 10px;
        padding: 30px 10px;
    }
}
</style>
